import theme from '../../../lib/theme';

const { corners, scale, layouts, colors, media } = theme;

export default () => ({
  container: {
    ...layouts.column,

    borderTop: `1px solid ${colors.grey}`,
    color: colors.black,
    textAlign: 'center',
    alignItems: 'center',
    padding: `${scale.m} ${scale.xs}`,

    [media.l.up]: {
      padding: `${scale.l} ${scale.s}`,
    },
  },

  meetups: {
    width: '100%',
    columnCount: 1,
    columnGap: scale.s,
    overflow: 'hidden',
    maxHeight: 170,
    position: 'relative',
    [media.s.up]: {
      columnCount: 3,
    },
    [media.l.up]: {
      columnCount: 6,
    },
  },

  meetup: {
    border: `1px solid ${colors.grey}`,
    borderRadius: corners.m,
  },
});
